import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    coinTable: '',
    vitaranStepScheme: [],  
    companyStepScheme: [],
};

const coinMgtSlice = createSlice({
    name: 'coinMgt',
    initialState,
    reducers: {
      getCoinTable: (state, action) => {
        state.coinTable = action.payload;
      },
      getVitaranStepSchemesData: (state, action) => {
        state.vitaranStepScheme = action.payload;
      },
      getCompanyStepSchemesData: (state, action) => {
        state.companyStepScheme = action.payload;
      },
    },
  });

export const { getCoinTable, getCompanyStepSchemesData, getVitaranStepSchemesData } = coinMgtSlice.actions;
export default coinMgtSlice.reducer;
export const CoinMgtData = (state) => state.coinMgt;

